<!-- This is placeholder content for the Game Streaming service (e.g. Reemo.io) -->
<script>
  // Alex's Awesome Debugger
  import { displayMode, sampleContent, showSample } from './stores.ts';

</script>

<!-- {#if $sampleContent == "racing"} -->
{#if $showSample }
  <video class="video-bg" preload="none" autoplay muted loop style="object-fit: {$displayMode} !important;">
  <!-- <video class="video-bg" preload="none" autoplay muted loop> -->
    <source src="vids/racing-game.mp4" type="video/mp4">
    <!-- <source src="vids/phils-game.mp4" type="video/mp4"> -->
    Browser does not support the video tag.
  </video>

<!-- {:else} -->

  <!-- <video class="video-bg" preload="none" autoplay muted loop style="object-fit: {$displayMode};">
    <source src="vids/flying-game.mp4" type="video/mp4">
    Browser does not support the video tag.
  </video> -->
{/if}

<style>
  :global(.video-bg) {
    /* filter: brightness(100); */
    z-index: 0;
    position: absolute;
    left: 0; top: 0;
    width:100%; height: 100%;
    object-fit: cover;
    overflow: hidden;
  }
  :global(.no-video) {
    display: none;
  }
</style>
